/**
 * @generated SignedSource<<541aa1f19c8508928f984008ce93429f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SelectTemporaryScreenMutation$variables = {
  id: string;
  screenId: string;
};
export type SelectTemporaryScreenMutation$data = {
  readonly dashboard: {
    readonly setTemporaryScreenId: {
      readonly id: string;
      readonly screens: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly temporaryScreen: {
        readonly id: string;
      } | null;
    };
  };
};
export type SelectTemporaryScreenMutation = {
  response: SelectTemporaryScreenMutation$data;
  variables: SelectTemporaryScreenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "screenId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "id"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "screenId",
            "variableName": "screenId"
          }
        ],
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "setTemporaryScreenId",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "screens",
            "plural": true,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StorecastScreen",
            "kind": "LinkedField",
            "name": "temporaryScreen",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectTemporaryScreenMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SelectTemporaryScreenMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "0c53abbd054588172e1c6e2096e293d2",
    "id": null,
    "metadata": {},
    "name": "SelectTemporaryScreenMutation",
    "operationKind": "mutation",
    "text": "mutation SelectTemporaryScreenMutation(\n  $id: ID!\n  $screenId: ID!\n) {\n  dashboard(dashboardId: $id) {\n    setTemporaryScreenId(screenId: $screenId) {\n      id\n      screens {\n        id\n      }\n      temporaryScreen {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4bbc59c431fcd0f0d47d31c7775f5d6";

export default node;
